const GENERIC_ERROR_MESSAGE = 'Qualcosa è andato storto. Riprovare.'

const STATUS_MESSAGES = {
  403: 'Permesso negato.',
  404: 'Elemento non trovato.',
  422: 'Dati non validi.',
  429: 'Troppe richieste. Riprova tra qualche istante.',
}

const hasOwn = (obj, key) => Object.prototype.hasOwnProperty.call(obj, key)

const isPlainObject = value => typeof value === 'object' && value !== null && !Array.isArray(value)

const getResponse = input => {
  if (isPlainObject(input) && isPlainObject(input.response)) {
    return input.response
  }
  if (isPlainObject(input) && typeof input.status === 'number' && hasOwn(input, 'data')) {
    return input
  }
  return null
}

const getPayload = input => {
  const response = getResponse(input)
  if (response) {
    return isPlainObject(response.data) ? response.data : null
  }
  if (isPlainObject(input) && hasOwn(input, 'code') && typeof input.status !== 'number') {
    return input
  }
  return null
}

const getErrorStatus = input => {
  const response = getResponse(input)
  return response ? response.status : null
}

const isApplicationFailure = input => {
  const payload = getPayload(input)
  if (!payload) {
    return false
  }
  const { code } = payload
  return code === 0 || code === '0'
}

const getErrorKey = input => {
  const status = getErrorStatus(input)
  if (isApplicationFailure(input) && (status === null || (status >= 200 && status < 300))) {
    return 'code0'
  }
  if (typeof status === 'number') {
    return status
  }
  return 'network'
}

const getErrorMessage = (input, overrides = {}) => {
  const key = getErrorKey(input)
  const overrideKey = String(key)
  if (hasOwn(overrides, overrideKey)) {
    return overrides[overrideKey]
  }
  if (hasOwn(STATUS_MESSAGES, overrideKey)) {
    return STATUS_MESSAGES[key]
  }
  if (hasOwn(overrides, 'default')) {
    return overrides.default
  }
  return GENERIC_ERROR_MESSAGE
}

const getFieldErrors = input => {
  if (!isApplicationFailure(input)) {
    return {}
  }
  const payload = getPayload(input)
  const data = payload ? payload.data : null
  if (!isPlainObject(data)) {
    return {}
  }
  return Object.keys(data)
    .filter(key => Array.isArray(data[key]))
    .reduce((acc, key) => ({ ...acc, [key]: data[key].map(String) }), {})
}

const getBackendMessage = input => {
  const payload = getPayload(input)
  return payload && typeof payload.message === 'string' ? payload.message : null
}

const logApiError = input => {
  const status = getErrorStatus(input)
  const backendMessage = getBackendMessage(input)
  // eslint-disable-next-line no-console
  console.log('[API error]', status, backendMessage || input)
}

let toastHandler = null

const setToastHandler = fn => {
  toastHandler = fn
}

const notifyApiError = (input, overrides = {}) => {
  const text = getErrorMessage(input, overrides)
  logApiError(input)
  if (toastHandler) {
    toastHandler({
      title: 'Errore!',
      text,
      icon: 'XIcon',
      variant: 'danger',
    })
  }
  return text
}

export default {
  GENERIC_ERROR_MESSAGE,
  STATUS_MESSAGES,
  getErrorStatus,
  isApplicationFailure,
  getErrorMessage,
  getFieldErrors,
  logApiError,
  setToastHandler,
  notifyApiError,
}
